import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";

// Custom Toast Hook
const useCustomToast = () => {
  const toast = useToast();

  const showToast = useCallback(
    (title, status, description = "") => {
      toast({
        title,
        description: description,
        position: "top",
        status,
        duration: 5000,
        isClosable: true,
      });
    },
    [toast]
  );

  return showToast;
};

export default useCustomToast;
